import React
    , {useContext} from "react";
import {CheckCircleIcon, ArrowLeftIcon} from "@heroicons/react/24/outline";
import {FormData} from "./FormProvider";
import PoweredByFormitize
    from "./PoweredByFormitize";

const SubmitSuccess = ({
                           origin,
                           onBack,
                           children,
                           ...rest
                       }) => {

    return (
        <div className='fz-form-success' {...rest}>
            <CheckCircleIcon width={50} className='fz-form-success-check-icon'/>
            <h1 className='fz-form-success-heading'>Form Submitted</h1>
            <p className='fz-form-success-text fz-form-success-thank-you'>Thank you for your submission.</p>

            <div className='fz-form-success-back-container'>
                <a href="#" className='fz-form-success-back-button' onClick={e => {
                    e.preventDefault();
                    onBack(e);
                }}><ArrowLeftIcon className='fz-form-success-back-button-icon' style={{height: 20, marginRight: '0.5rem' }} /><span>Back to form</span></a>
            </div>

            <PoweredByFormitize />
        </div>
    )
}

export default SubmitSuccess;